import { allExpanded, defaultStyles, JsonView } from 'react-json-view-lite';
import { Trans } from '@lingui/react/macro';

import InputText from '@/design_system/InputText';
import Stack from '@/design_system/Stack';
import Title from '@/design_system/Typography/Title';
import { useCurrentOrganization } from '@/services/auth';

import { SettingsSectionLayout } from '../components/Layout/Layout';

export const Organization = () => {
  const [currentOrganization] = useCurrentOrganization();

  return (
    <SettingsSectionLayout title={<Trans id="settings-section.organization">Organization</Trans>}>
      {currentOrganization && (
        <main>
          <Stack gap="0.5rem">
            <InputText
              value={currentOrganization.name}
              label={<Trans id="support.general.general.name">Name</Trans>}
              isDisabled
            />
            {currentOrganization.nameAlias ? (
              <InputText
                value={currentOrganization.nameAlias}
                label={<Trans id="support.general.general.name_alias">Alias</Trans>}
                isDisabled
              />
            ) : null}
          </Stack>
          <Title as="h2" size="300" weight="medium">
            <Trans id="support.general.configuration">Configuration</Trans>
          </Title>
          <JsonView
            data={currentOrganization.config}
            shouldExpandNode={allExpanded}
            style={defaultStyles}
          />
        </main>
      )}
    </SettingsSectionLayout>
  );
};
